import { z } from 'zod';
import { MAX_DENY_LIST_ITEMS } from '../constants.js';

export const denyListSchema = z.object({
  items: z
    .array(z.string().min(1).max(100, 'Each item must be 100 characters or less'))
    .max(MAX_DENY_LIST_ITEMS, `Deny list cannot exceed ${MAX_DENY_LIST_ITEMS} items`),
}).strict();

export type DenyListInput = z.infer<typeof denyListSchema>;
